import React from 'react';
import PropTypes from 'prop-types';

const toTitleCase = (str) =>
	str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

const CategoryGroupHeader = ({ tabName, categorySlug, vehicleCount }) => {
	return (
		<div
			id={`category-${categorySlug}`}
			className="category-group-header d-flex align-items-center gap-2 px-3 py-2 border-bottom mb-3"
		>
			<i
				className={`ddc-icon ddc-icon-size-xlarge ddc-icon-${categorySlug} text-${categorySlug}`}
				aria-hidden="true"
			/>
			<h2 className="ddc-font-size-large text-primary m-0 pl-3">
				{toTitleCase(tabName)}{' '}
				<span className="text-muted ddc-font-size-small">
					({vehicleCount}{' '}
					{vehicleCount === 1 ? 'vehicle' : 'vehicles'})
				</span>
			</h2>
		</div>
	);
};

CategoryGroupHeader.propTypes = {
	tabName: PropTypes.string.isRequired,
	categorySlug: PropTypes.string.isRequired,
	vehicleCount: PropTypes.number.isRequired
};

export default CategoryGroupHeader;
